import gql from 'graphql-tag'

export const fetchProductsQuery = gql`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_id: [String]
    $category_uid: [String]
    $pack_format: [String]
    $sub_brand: [String]
    $volume: [String]
    $currentPage: Int!
    $pageSize: Int
    $is_peroni: Boolean = false
    $product_last: String
    $product_new: String
    $product_sale: String
    $product_recommended: String
    $promotional: String
    $free_beer: String
    $product_lowstock: String
    $product_type: String,
    $material_type: String
  ) {
    products(
      search: $search
      filter: {
        sku: { in: $sku }
        type_id: {eq: $product_type}
        brand: { in: $brand }
        sub_brand: { in: $sub_brand }
        category_id: { in: $category_id }
        category_uid: { in: $category_uid }
        pack_format: { in: $pack_format }
        volume: { in: $volume }
        product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        product_sale: { eq: $product_sale }
        product_recommended: { eq: $product_recommended }
        promotional: { eq: $promotional }
        product_lowstock: { eq: $product_lowstock }
        free_beer: { eq: $free_beer }
        material_type:{ eq: $material_type}
      }
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      total_count
      categoryFilter {
        category_name
        category_uid
        category_id
      }
      aggregations {
        attribute_code
        count
        label
        options {
          label
          value
          count
        }
      }
      items {
        free_beer_details
        {
          id
          req_id
          qty
          product_id
          free_beer
          iSameFreeProductAlreadyInCart
          disable
          remainingqty
          item_id
        }
        special_offer_details{
          max_purchasable_qty
          valid_from
          valid_to
          deliverable_from
          deliverable_to
          deliverable_flag
        }
        low_stock_pl {
          is_lowstock
          out_of_stock
          rotation_day
          quantity
        }
        quantity_selector_layer
        quantity_selector_pallet
        high_margin
        hectolitres_fe
        multi_deposit
        material_type
        number_of_items_in_box
        name
        catalog_product_name
        deliveryDate
        sku
        disable_for_pallet_ordering_fe
        disable_for_layer_ordering_fe
        your_price
        your_price_tax
        total_price
        favourites
        promo
        product_last
        product_new
        product_sale
        product_recommended
        product_lowstock
        promotional
        free_beer
        number_of_products_on_layer
        number_of_items_on_pallet
        number_of_layers_per_pallet
        isavailable_truck_package_ordering
        volume
        description {
          html
        }
        features @include(if: $is_peroni) {
          tipo_birra
          provenienza
          gradazione_alcolica
          termine_conservazione
        }
        small_image {
          url
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
          total_units
        }
        ... on BundleProduct {
          your_price_sum
          your_price_sum_tax
          bundle_price_sum
          bundle_price_sum_tax
          bundle_fields {
            minimum_amt
            valid_from
            valid_to
            limited_amount
          }
          items {

            
            option_id
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                id
                name
                catalog_product_name
                name
                sku
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
                your_price
                your_price_tax
              }
            }
          }
        }
      }
      page_info {
        page_size
        total_pages
        current_page
      }
    }
  }
`
